import { ChatType } from '@anyx/common-graphql';

import { useCrmStore } from './useCrmStore';

export const CHAT_TYPE_DISPLAY_ORDERS = [
  ChatType.LINE,
  ChatType.INSTAGRAM,
  ChatType.MESSENGER,
  ChatType.WHATSAPP,
  ChatType.SHOPEE,
  ChatType.LAZADA,
  ChatType.TIKTOK_SHOP,
];

export const useIsStoreConnectedToAnyChat = () => {
  return useCrmStore((state) => Object.keys(state.chats).length > 0);
};

export const useIsStoreConnectedToLine = () => {
  return useCrmStore((state) => ChatType.LINE in state.chats);
};

export const useIsStoreConnectedToInstagram = () => {
  return useCrmStore((state) => ChatType.INSTAGRAM in state.chats);
};

export const useIsStoreConnectedToMessenger = () => {
  return useCrmStore((state) => ChatType.MESSENGER in state.chats);
};

export const useIsStoreConnectedToWhatsapp = () => {
  return useCrmStore((state) => ChatType.WHATSAPP in state.chats);
};

export const useIsStoreConnectedToLazada = () => {
  return useCrmStore((state) => ChatType.LAZADA in state.chats);
};

export const useIsStoreConnectedToShopee = () => {
  return useCrmStore((state) => ChatType.SHOPEE in state.chats);
};

export const useIsStoreConnectedToTiktokShop = () => {
  return useCrmStore((state) => ChatType.TIKTOK_SHOP in state.chats);
};

export const useIsStoreOnlyConnectedToLine = () => {
  const onlyOneConnection = useCrmStore((state) => Object.keys(state.chats).length === 1);
  const connectedLine = useIsStoreConnectedToLine();

  return onlyOneConnection && connectedLine;
};

export const useIsStoreCommercialMode = () => {
  return useCrmStore((state) => !state.isInfluencerMode);
};

export const useIsStoreInfluencerMode = () => {
  return useCrmStore((state) => state.isInfluencerMode);
};

export const useDisconnectedStoreChats = () => {
  const chats = useCrmStore((state) => state.chats);

  return Object.values(chats)
    .filter((channel) => channel.disconnected)
    .map((channel) => channel.type);
};

export const useStoreChatTypeConnectedOrders = () => {
  const chats = useCrmStore((state) => state.chats);

  return CHAT_TYPE_DISPLAY_ORDERS.filter((order) => order in chats);
};
